var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-swipe',{ref:"mySwipe",attrs:{"autoplay":4000,"indicator-color":"white"}},_vm._l((_vm.bannerData),function(p,index){return _c('van-swipe-item',{key:index},[_c('img',{staticClass:"d-block img-fluid w-100",attrs:{"src":p.picUrl,"alt":"image slot"},on:{"click":function($event){return _vm.openChat()}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }